import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";

export default function CaregiverRankHeading(props: {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  name: string;
  wage: number;
}) {
  const Icon = props.icon;

  return (
    <Root>
      <IconContainer>
        <Icon width={40} color="var(--tw-blue-500)" />
      </IconContainer>
      <Name>{props.name}</Name>
      <Wage>
        ${props.wage} {translate(STRINGS.PER_HOUR)}
      </Wage>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const IconContainer = styled.div``;

const Name = styled.div`
  font-weight: 700;
`;

const Wage = styled.div`
  font-weight: 300;
`;
